import styled from "@emotion/styled"
import CircularProgress from "@mui/material/CircularProgress"
import Typography from "@mui/material/Typography"

const Wrapper = styled.div`
    width: 200px;
    margin: 96px auto;
    text-align: center;
`;

const LoadingContainer: React.FC = () => {
    return (
        <Wrapper>
            <CircularProgress size={48} color="inherit" />
            <Typography variant="body1" sx={{marginTop: "16px"}}>Laster...</Typography>
        </Wrapper>
    )
}

export default LoadingContainer